import { Alert, Layout } from 'antd'
import { AlertProps } from 'antd/lib/alert'
import * as React from 'react'
import {
    CollapsibleSidebar,
    FixedSidebar,
    SiteContent,
    SiteHeader
} from './components'
import { SiteLayoutContext } from './contexts'
import { FixedHeaderLayout } from '../schedio-layout'
import { useSchedioSiteLayout } from './useSchedioSiteLayout'
import * as styles from './SchedioSiteLayout.module.less'
import { useMediaQueries } from '../'

export interface SchedioSiteLayoutProps {
    isSidebarCollapsed?: boolean
    alertProps?: AlertProps
    content?: React.ReactNode
    header?: React.ReactNode
    sidebar?: {
        collapsibleSidebar?: React.ReactNode
        fixedSidebar?: React.ReactNode
    }

    collapsed?: boolean
    toggle?: () => void
}

export const SchedioSiteLayout: React.FC<SchedioSiteLayoutProps> = (props) => {
    const { content, header, sidebar } = props
    const { collapsibleSidebar, fixedSidebar } = sidebar || {}
    const initialCollapsed =
        props.isSidebarCollapsed !== undefined
            ? props.isSidebarCollapsed
            : false
    const showBanner = props.alertProps ? true : false
    const uncontrolled = useSchedioSiteLayout({ initialCollapsed })
    const controlled = { collapsed: props.collapsed, toggle: props.toggle }

    const { isMobile } = useMediaQueries()

    const schedioLayoutClassName = `${styles.schedioSiteLayout} schedioSiteLayout`

    let siteLayoutStyle: React.CSSProperties = {}
    if (isMobile) {
        siteLayoutStyle = { height: window.innerHeight }
    }

    const { collapsed, toggle } =
        props.toggle === undefined ? uncontrolled : controlled

    return (
        // @ts-ignore
        <SiteLayoutContext.Provider value={{ collapsed, toggle }}>
            <div
                className={schedioLayoutClassName}
                style={{
                    ...siteLayoutStyle
                }}
            >
                {/* @ts-ignore  */}
                {showBanner ? <Alert banner {...props.alertProps} /> : null}
                <Layout style={{ height: '100%' }}>
                    {fixedSidebar && (
                        <FixedSidebar fixedSidebar={fixedSidebar} />
                    )}
                    {collapsibleSidebar && (
                        <CollapsibleSidebar
                            collapsibleSidebar={collapsibleSidebar}
                            // @ts-ignore
                            collapsed={collapsed}
                        />
                    )}
                    <FixedHeaderLayout
                        content={content}
                        header={header && <SiteHeader children={header} />}
                    />
                </Layout>
            </div>
        </SiteLayoutContext.Provider>
    )
}
